import { render, staticRenderFns } from "./AgentDetailRight.vue?vue&type=template&id=6500d9ea"
import script from "./AgentDetailRight.vue?vue&type=script&lang=js"
export * from "./AgentDetailRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports